import {
  BACK_MERCHANT,
  CONFIRM_BANK,
  CREATE_LINK_EVENT,
  CREATE_OBV,
  CREATE_PLAID_LINK,
  CONTINUE_OAUTH_CALLBACK,
  EXIT_EVENT,
  OBV_VERIFICATION,
  ADD_PROPERTIES
} from './types';

// CREATE OBV SECTION
export const createOBV = (OBVInfo) => ({
  type: CREATE_OBV,
  OBVInfo
});

// CREATE PLAID LINK
export const createPlaidLink = (merchantReturnUrl, deviceData) => ({
  type: CREATE_PLAID_LINK,
  merchantReturnUrl,
  deviceData
});


// CREATE PLAID LINK EVENT
export const createPlaidEvent = (eventName, metadata) => ({
  type: CREATE_LINK_EVENT,
  eventName,
  metadata,
});

// VERIFY OBV
export const obvVerification = (metadata) => ({
  type: OBV_VERIFICATION,
  metadata,
});

// Continue OAuth callback
export const continueOAuthCallback = (deviceData, receivedRedirectUri) => ({
  type: CONTINUE_OAUTH_CALLBACK,
  deviceData,
  receivedRedirectUri
});

// Confirm bank
export const confirmationBank = (clientReferenceId) => ({
  type: CONFIRM_BANK,
  clientReferenceId,
});


// Exit event
export const exitEvent = (event) => ({
  type: EXIT_EVENT,
  event,
});


// Back Merchant
export const backMerchant = () => ({
  type: BACK_MERCHANT,
});

export const addProperties = (properties) => ({
  type: ADD_PROPERTIES,
  properties
});